import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles }) => {
  const userRole = localStorage.getItem('userRole');
  console.log("UserRole in ProtectedRoute:", userRole, allowedRoles); // clearly verify here ✅

  if (!userRole || !allowedRoles.includes(userRole)) {
    console.log("Redirecting back to login: unauthorized clearly"); // ✅
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;